import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './About.css';

function AboutUs() {
    return (
        <section className="about-us">
            <div className="position-relative">
                <img src="/images/aboutimg.svg" alt="About Us" className="img-fluid w-100" />
                <div className="position-absolute about-header-text top-50 start-50 translate-middle text-center">
                    <h1 className="text-white">About Us</h1>
                </div>
            </div>
            <div className="about-content d-flex flex-wrap py-4 text-dark">
                <div className="col-md-6 d-flex justify-content-center">
                    <img src="/images/img.svg" alt="About Content" className="img-fluid about-content-image" />
                </div>
                <div className="col-md-6 about-content-text">
                    <p>Welcome to DM, where we are passionate about revolutionizing the world of HR solutions. With 10yrs experience and expertise, we are dedicated to providing seamless recruitment and onboarding experiences for businesses of all sizes.</p>
                    <p>Our journey began with the vision to simplify the hiring process and create a positive impact on organizations. Since our founding, we have achieved numerous milestones and helped countless clients achieve their recruitment goals.</p>
                    <p>With a team of industry experts, we bring a wealth of knowledge and experience to the table. Our certified professionals stay up to date with the latest trends and best practices in the HR industry, ensuring that we provide cutting-edge solutions tailored to your unique needs.</p>
                </div>
            </div>
        </section>
    );
}

export default AboutUs;